import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Modal, Button, Label} from "reactstrap";
import {Formik, Form, Field, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {capitalizeFirst, removeEmptyFormField} from "../../../common/general";
import {analyticalAccountsEdit, analyticalAccountsNew} from "../../../store/companies/analyticalAccounts/actions";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: "",
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({loading: this.props.loading, response: this.props.response, error: this.props.error});
      if (this.props.response.status === 0) {
        this.props.refreshParent({history: this.props.history})
        this.onClose()
      }
    }
  }

  onClose = () => {
    this.props.togModal()
  }

  render() {
    const requiredName = Yup.string().required("Please enter name")
    const requiredDescription = Yup.string().required("Please enter description")

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {capitalizeFirst(this.props.action)} Analytical Account
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <Formik
          initialValues={{
            name: this.props.action === "new" ? "" : this.props.analyticalAccountData.name,
            description: this.props.action === "new" ? "" : this.props.analyticalAccountData.description,
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().min(3, 'Name is too short').max(6, 'Name is too long').concat(this.props.action === "new" ? requiredName : null),
            description: Yup.string().concat(this.props.action === "new" ? requiredDescription : null),
          })}
          onSubmit={values => {
            const {onAnalyticalAccountsNew, onAnalyticalAccountsEdit} = this.props
            if (this.props.action === "new") {
              onAnalyticalAccountsNew({history: this.props.history, companyId: this.props.companyId, values: values})
            } else {
              onAnalyticalAccountsEdit({history: this.props.history, companyId: this.props.companyId, analyticalAccountId: this.props.analyticalAccountData.id, values: removeEmptyFormField(values)})
            }
          }}
        >
          {({errors, status, touched}) => (<Form>
            <div className="modal-body">
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="name">
                      Name
                    </Label>
                    <Field
                      id="name"
                      name="name"
                      placeholder="Enter name"
                      type="text"
                      className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="description">
                      Description
                    </Label>
                    <Field
                      id="description"
                      name="description"
                      placeholder="Enter description"
                      type="text"
                      className={"form-control" + (errors.description && touched.description ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                <span className="sr-only">Loading...</span>
              </div>)}
              {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.error}
              </Alert>)}
              <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                Close
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>)}
        </Formik>
      </Modal>
    </React.Fragment>)
  }
}

NewModal.propTypes = {
  response: PropTypes.any,
  onAnalyticalAccountsNew: PropTypes.func,
  onAnalyticalAccountsEdit: PropTypes.func,
};

const mapStateToProps = ({AnalyticalAccounts}) => ({
  response: AnalyticalAccounts.responseNew,
  loading: AnalyticalAccounts.loadingNew,
  error: AnalyticalAccounts.errorNew,
});

const mapDispatchToProps = dispatch => ({
  onAnalyticalAccountsNew: data => dispatch(analyticalAccountsNew(data)),
  onAnalyticalAccountsEdit: data => dispatch(analyticalAccountsEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));